import { BlazonCardContent } from 'app/common/blazon/card/content/BlazonCardContent'
import { H5, Text } from 'app/common/typography'
import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import { colors } from 'shared/assets/styles'
import type { Blazon } from 'shared/types'
import styled from 'styled-components'

const { shadow, lightGrey, grey } = colors

type Props = {
    blazons: Array<Blazon>,
    onClickBlazon: (blazon: Blazon) => void
}

const ChallengesPartnersSection = (props: Props) => {
    const { blazons, onClickBlazon } = props

    return (
        <PartnersSection>
            <H5>
                <FormattedMessage id="kingdom.challenges.partners.title" />
            </H5>
            {blazons.length > 0 ? (
                blazons.map((blazon, index) => (
                    <Fragment key={index}>
                        {index > 0 && <Divider />}
                        <BlazonCardContent
                            blazon={blazon}
                            onClick={() => onClickBlazon(blazon)}
                            isButtonAlignedRight
                        />
                    </Fragment>
                ))
            ) : (
                <Paragraph>
                    <Description>
                        <FormattedMessage id="kingdom.challenges.partners.none" />
                    </Description>
                </Paragraph>
            )}
        </PartnersSection>
    )
}

const PartnersSection = styled.section`
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 700px;
    padding: 16px 16px 24px;
    box-shadow: 0 0 15px ${shadow};
    border-radius: 10px;
    background-color: white;
    width: 90%;
`

const Divider = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${lightGrey};
`

const Paragraph = styled.p`
    text-align: center;
    padding: 0 16px;
`

const Description = styled(Text)`
    white-space: pre-line;
    color: ${grey};
`

export { ChallengesPartnersSection }
